export const INPUT_GROUP_CLASS = 'input-group';
export const INPUT_GROUP_HIDDEN_CLASS = 'input-group-hidden';